import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-intermediatePoint",
  "use": "icon-intermediatePoint-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intermediatePoint\"><path d=\"M512 671.885c-10.956 0-21.65-1.096-31.99-3.206v291.018h63.957v-291.02c-10.324 2.112-21.013 3.208-31.967 3.208zm-31.99-316.562c10.34-2.11 21.034-3.207 31.99-3.207s21.644 1.097 31.968 3.207V64.304h-63.957v291.02zM416.067 512c0-52.975 42.938-95.92 95.933-95.92 52.989 0 95.934 42.946 95.934 95.92 0 52.975-42.945 95.948-95.934 95.948-52.995 0-95.933-42.973-95.933-95.947z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol